import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ImportService } from 'src/app/services/imports/import.service';
import { ColDef, ITooltipParams } from 'ag-grid-community';
import { CustomersTanksImportResponse, CustomersTanksSaveRequest } from 'src/app/models/import/import.model';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-customers-tanks-import',
  templateUrl: './customers-tanks-import.component.html',
  styleUrls: ['./customers-tanks-import.component.scss']
})
export class CustomersTanksImportComponent {
  @Input() isClientSpecific: boolean = false;
  @Input() uploadType: 'customers-tanks' | 'client-customers-tanks' = 'customers-tanks';
  @Output() back = new EventEmitter<void>();
  @Output() importCompleted = new EventEmitter<void>();
  downloaded = false;
  uploaded = false;
  validated = false;
  errors: string[] = [];
  tankTypes: string[] = [];
  customerNames: string[] = [];
  customers: any[] = [];
  tanks: any[] = [];
  gridApiCustomers: any;
  gridColumnApiCustomers: any;
  gridApiTanks: any;
  gridColumnApiTanks: any;
  validationErrors: string[] = [];
  allRowsValid: boolean = false;
  alreadyHaveTemplate: boolean = false;
  selectedFile: File | null = null;
  selectedDistId?: number;
  isValidating = false;
  isSaving = false;

    defaultColDef: any = {
        sortable: false,
        filter: false,
        resizable: true,
        editable: true
    };

    customerColumnDefs: ColDef[] = [
        {
            headerName: 'Company Name',
            field: 'companyName',
            editable: true,
            cellClass: (params: any) =>
                params.data?.errors?.some((e: string) =>
                    e.toLowerCase().includes('companyname')
                )
                    ? 'cell-error'
                    : '',
            tooltipValueGetter: (params: ITooltipParams) =>
                params.data?.errors?.find((e: string) =>
                    e.toLowerCase().includes('companyname')
                )
        },
        {
            headerName: 'First Name',
            field: 'firstName',
            editable: true,
            cellClass: (params: any) =>
                params.data?.errors?.some((e: string) =>
                    e.toLowerCase().includes('firstname')
                )
                    ? 'cell-error'
                    : '',
            tooltipValueGetter: (params: ITooltipParams) =>
                params.data?.errors?.find((e: string) =>
                    e.toLowerCase().includes('firstname')
                )
        },
        {
            headerName: 'Last Name',
            field: 'lastName',
            editable: true,
            cellClass: (params: any) =>
                params.data?.errors?.some((e: string) =>
                    e.toLowerCase().includes('lastname')
                )
                    ? 'cell-error'
                    : '',
            tooltipValueGetter: (params: ITooltipParams) =>
                params.data?.errors?.find((e: string) =>
                    e.toLowerCase().includes('lastname')
                )
        },
        {
            headerName: 'Account Number',
            field: 'accountNumber',
            editable: true
        },
        {
            headerName: 'Email',
            field: 'email',
            editable: true,
            cellClass: (params: any) =>
                params.data?.errors?.some((e: string) =>
                    e.toLowerCase().includes('email')
                )
                    ? 'cell-error'
                    : '',
            tooltipValueGetter: (params: ITooltipParams) =>
                params.data?.errors?.find((e: string) =>
                    e.toLowerCase().includes('email')
                )
        },
        {
            headerName: 'Phone',
            field: 'phone',
            editable: true,
            cellClass: (params: any) =>
                params.data?.errors?.some((e: string) =>
                    e.toLowerCase().includes('phone')
                )
                    ? 'cell-error'
                    : '',
            tooltipValueGetter: (params: ITooltipParams) =>
                params.data?.errors?.find((e: string) =>
                    e.toLowerCase().includes('phone')
                )
        },
        {
            headerName: 'Street',
            field: 'addressStreet',
            editable: true
        },
        {
            headerName: 'City',
            field: 'city',
            editable: true
        },
        {
            headerName: 'State',
            field: 'state',
            editable: true,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: () => ({
                values: this.states,
                allowTyping: false,
                searchDebounceDelay: 0
            }),
            cellClass: (params: any) =>
                params.data?.errors?.some((e: string) =>
                    e.toLowerCase().includes('state')
                )
                    ? 'cell-error'
                    : '',
            tooltipValueGetter: (params: ITooltipParams) =>
                params.data?.errors?.find((e: string) =>
                    e.toLowerCase().includes('state')
                )
        },
        {
            headerName: 'Postal Code',
            field: 'postalCode',
            editable: true,
            cellClass: (params: any) =>
                params.data?.errors?.some((e: string) =>
                    e.toLowerCase().includes('postalcode')
                )
                    ? 'cell-error'
                    : '',
            tooltipValueGetter: (params: ITooltipParams) =>
                params.data?.errors?.find((e: string) =>
                    e.toLowerCase().includes('postalcode')
                )
        }
    ];

    extraTankColumns: ColDef[] = [
        {
            headerName: 'Location Id',
            field: 'locationId',
            editable: true
        }
    ];

    tankColumnDefs: ColDef[] = [];

    states: string[] = [
        // US States
        "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
        "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
        "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
        "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
        "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY",

        // Canadian Provinces & Territories
        "AB", "BC", "MB", "NB", "NL", "NS", "NT", "NU", "ON", "PE",
        "QC", "SK", "YT"
    ];


  constructor(private importService: ImportService,
    private toastService: ToastrService
  ) {}

  ngOnInit() {
    this.selectedDistId = Number(localStorage.getItem('distid')??"");
    this.tankColumnDefs = this.buildTankColumns();
  }


    private buildTankColumns(): ColDef[] {
        return [
            {
                headerName: 'Tank ID',
                field: 'tankID',
                editable: true,
                cellClass: (params: any) =>
                    params.data?.errors?.some((e: string) =>
                        e.toLowerCase().includes('tankid')
                    )
                        ? 'cell-error'
                        : '',
                tooltipValueGetter: (params: ITooltipParams) =>
                    params.data?.errors?.find((e: string) =>
                        e.toLowerCase().includes('tankid')
                    )
            },
            {
                headerName: 'Tank Type',
                field: 'tankType',
                editable: true,
                cellEditor: 'agRichSelectCellEditor',
                cellEditorParams: () => ({
                    values: this.tankTypes,
                    allowTyping: false,
                    searchDebounceDelay: 0
                }),
                cellClass: (params: any) =>
                    params.data?.errors?.some((e: string) =>
                        e.toLowerCase().includes('tanktype')
                    )
                        ? 'cell-error'
                        : '',
                tooltipValueGetter: (params: ITooltipParams) =>
                    params.data?.errors?.find((e: string) =>
                        e.toLowerCase().includes('tanktype')
                    )
            },
            {
                headerName: 'Capacity',
                field: 'capacity',
                editable: true,
                cellClass: (params: any) =>
                    params.data?.errors?.some((e: string) =>
                        e.toLowerCase().includes('capacity')
                    )
                        ? 'cell-error'
                        : '',
                tooltipValueGetter: (params: ITooltipParams) =>
                    params.data?.errors?.find((e: string) =>
                        e.toLowerCase().includes('capacity')
                    )
            },
            {
                headerName: 'Related Customer',
                field: 'relatedCustomer',
                editable: true,
                cellEditor: 'agRichSelectCellEditor',
                cellEditorParams: () => ({
                    values: this.customerNames,
                    allowTyping: false,
                    searchDebounceDelay: 0
                }),
                cellClass: (params: any) =>
                    params.data?.errors?.some((e: string) =>
                        e.toLowerCase().includes('relatedcustomer')
                    )
                        ? 'cell-error'
                        : '',
                tooltipValueGetter: (params: ITooltipParams) =>
                    params.data?.errors?.find((e: string) =>
                        e.toLowerCase().includes('relatedcustomer')
                    )
            },
            { headerName: 'Street', field: 'addressStreet', editable: true },
            { headerName: 'City', field: 'city', editable: true },
            {
                headerName: 'State',
                field: 'state',
                editable: true,
                cellEditor: 'agRichSelectCellEditor',
                cellEditorParams: () => ({
                    values: this.states,
                    allowTyping: false,
                    searchDebounceDelay: 0
                }),
                cellClass: (params: any) =>
                    params.data?.errors?.some((e: string) =>
                        e.toLowerCase().includes('state')
                    )
                        ? 'cell-error'
                        : '',
                tooltipValueGetter: (params: ITooltipParams) =>
                    params.data?.errors?.find((e: string) =>
                        e.toLowerCase().includes('state')
                    )
            },
            {
                headerName: 'Postal Code',
                field: 'postalCode',
                editable: true,
                cellClass: (params: any) =>
                    params.data?.errors?.some((e: string) =>
                        e.toLowerCase().includes('postalcode')
                    )
                        ? 'cell-error'
                        : '',
                tooltipValueGetter: (params: ITooltipParams) =>
                    params.data?.errors?.find((e: string) =>
                        e.toLowerCase().includes('postalcode')
                    )
            },

            // Conditional LocationId column
            ...(this.isClientSpecific ? this.extraTankColumns : [])
        ];
    }


  downloadTemplate() {
  const fileName = this.isClientSpecific
    ? 'client-customers-tanks-template.xlsx'
    : 'customers-tanks-template.xlsx';

  window.open(`assets/templates/${fileName}`, '_blank');
  this.downloaded = true;
}



    onCustomersGridReady(params: any) {
        this.gridApiCustomers = params.api;
        this.gridColumnApiCustomers = params.columnApi;

        if (this.customers?.length) {
            this.gridApiCustomers.setRowData(this.customers);
        }
    }

    onCustomerCellValueChanged(event: any) {
        this.gridApiCustomers.stopEditing();

        const row = event.data;
        row.errors = this.validateCustomerRow(row);

        event.api.refreshCells({
            rowNodes: [event.node],
            force: true
        });

        this.updateAllRowsValid();
    }

    onTanksGridReady(params: any) {
        this.gridApiTanks = params.api;
        this.gridColumnApiTanks = params.columnApi;

        if (this.tanks?.length) {
            this.gridApiTanks.setRowData(this.tanks);
        }
    }

    onTankCellValueChanged(event: any) {
        this.gridApiTanks.stopEditing();

        const row = event.data;
        row.errors = this.validateTankRow(row);

        event.api.refreshCells({
            rowNodes: [event.node],
            force: true
        });

        this.updateAllRowsValid();
    }


    onFileSelected(event: any) {
        const file = event.target.files[0];
        if (!file) return;

        this.isValidating = true;
        this.uploaded = true;
        this.validationErrors = [];
        this.allRowsValid = false;

        // Reset previous data
        this.customers = [];
        this.tanks = [];
        this.customerNames = [];
        this.tankTypes = [];

        (
            this.importService.upload(
                this.uploadType,
                file,
                this.selectedDistId!
            ) as Observable<CustomersTanksImportResponse>
        )
            .subscribe({
                next: (response: CustomersTanksImportResponse) => {

                    this.isValidating = false;

                    // Assign row data
                    this.customers = response.customers || [];
                    this.tanks = response.tanks || [];

                    // Dropdown lists
                    this.customerNames = response.customerNames || [];
                    this.tankTypes = response.tankTypes || [];

                    // Validation summary
                    this.validationErrors = response.errors || [];

                    // Determine if all rows are valid
                    this.allRowsValid =
                        this.customers.every(r => r.errors?.length === 0) &&
                        this.tanks.every(r => r.errors?.length === 0);

                    // Populate grids if APIs are ready
                    if (this.gridApiCustomers) {
                        this.gridApiCustomers.setRowData(this.customers);
                        this.gridApiCustomers.refreshCells({ force: true });
                    }

                    if (this.gridApiTanks) {
                        this.gridApiTanks.setRowData(this.tanks);
                        this.gridApiTanks.refreshCells({ force: true });
                    }
                },

                error: () => {
                    this.validationErrors = ['Upload failed. Please try again.'];
                    this.allRowsValid = false;
                    this.isValidating = false;
                }
            });
    }


    validateCustomerRow(row: any): string[] {
        const errors: string[] = [];

        const company = row.companyName?.trim();
        const first = row.firstName?.trim();
        const last = row.lastName?.trim();

        // Customer type inference rules
        if (!company && (!first || !last)) {
            errors.push("Either CompanyName OR FirstName + LastName is required");
        }

        if (!this.isClientSpecific) {
            if (company && first && last) {
                errors.push("Provide either CompanyName OR FirstName + LastName, not both");
            }
        }

        // Email validation (optional)
        if (row.email) {
            const email = row.email.trim();
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                errors.push("Email format is invalid");
            }
        }

        // Phone validation (optional)
        if (row.phone) {
            const digits = row.phone.replace(/\D/g, "");
            if (digits.length !== 10) {
                errors.push("Phone must contain 10 digits");
            }
        }

        // State/Province validation (dropdown ensures correctness)
        if (row.state && !this.states.includes(row.state.trim())) {
            errors.push("State/Province is invalid");
        }

        // Postal code validation (optional)
        if (row.postalCode) {
            const pc = row.postalCode.trim();
            const usZip = /^\d{5}(-\d{4})?$/;
            const caPostal = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

            if (!usZip.test(pc) && !caPostal.test(pc)) {
                errors.push("PostalCode must be valid");
            }
        }

        return errors;
    }

    validateTankRow(row: any): string[] {
        const errors: string[] = [];

        // Required fields
        if (!row.tankID?.trim()) {
            errors.push("TankID is required");
        }

        if (!row.tankType?.trim()) {
            errors.push("TankType is required");
        }

        if (!row.capacity || isNaN(row.capacity)) {
            errors.push("Capacity must be a number");
        }

        // RelatedCustomer (dropdown ensures correctness)
        if (!row.relatedCustomer?.trim()) {
            errors.push("RelatedCustomer is required");
        }

        // State/Province validation
        if (row.state && !this.states.includes(row.state.trim())) {
            errors.push("State/Province is invalid");
        }

        // Postal code validation
        if (row.postalCode) {
            const pc = row.postalCode.trim();
            const usZip = /^\d{5}(-\d{4})?$/;
            const caPostal = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

            if (!usZip.test(pc) && !caPostal.test(pc)) {
                errors.push("PostalCode must be valid");
            }
        }

        const hasLocationIdColumn = 'locationId' in row;
        if (hasLocationIdColumn) {
            if (!row.locationId || !row.locationId.trim()) {
                errors.push("LocationID is required");
            }
        }

        return errors;
    }

    validateCrossSheet() {
        const validNames = new Set(this.customerNames.map(n => n.trim()));

        for (const tank of this.tanks) {
            if (tank.relatedCustomer && !validNames.has(tank.relatedCustomer.trim())) {
                tank.errors.push("RelatedCustomer does not match any customer");
            }
        }
    }

    revalidateAll() {
        this.gridApiCustomers?.stopEditing();
        this.gridApiTanks?.stopEditing();

        this.validationErrors = [];

        // Validate customers
        for (const row of this.customers) {
            row.errors = this.validateCustomerRow(row);
            if (row.errors.length > 0) {
                this.validationErrors.push(
                    `Customer Row ${row.rowNumber}: ${row.errors.join(", ")}`
                );
            }
        }

        // Validate tanks
        for (const row of this.tanks) {
            row.errors = this.validateTankRow(row);
            if (row.errors.length > 0) {
                this.validationErrors.push(
                    `Tank Row ${row.rowNumber}: ${row.errors.join(", ")}`
                );
            }
        }

        // Rebuild customerNames from corrected customer rows
        this.customerNames = this.customers
            .map(c => this.getDisplayName(c))
            .filter(n => n && n.trim().length > 0);


        // Cross-sheet validation
        this.validateCrossSheet();

        // Recalculate allRowsValid
        this.allRowsValid =
            this.customers.every(r => r.errors.length === 0) &&
            this.tanks.every(r => r.errors.length === 0);

        // Refresh both grids
        this.gridApiCustomers?.refreshCells({ force: true });
        this.gridApiTanks?.refreshCells({ force: true });

        if (!this.allRowsValid) {
            setTimeout(() => this.scrollToFirstError(), 50);
        }
    }

    getDisplayName(c: any): string {
        if (c.companyName?.trim()) return c.companyName.trim();
        if (c.firstName?.trim() && c.lastName?.trim()) {
            return `${c.firstName.trim()} ${c.lastName.trim()}`;
        }
        return '';
    }

    onCustomerCellEditingStopped(event: any) {
        this.gridApiCustomers.stopEditing();

        const row = event.data;
        row.errors = this.validateCustomerRow(row);

        event.api.refreshCells({ rowNodes: [event.node], force: true });

        this.updateAllRowsValid();
    }

    onTankCellEditingStopped(event: any) {
        this.gridApiTanks.stopEditing();

        const row = event.data;
        row.errors = this.validateTankRow(row);

        event.api.refreshCells({ rowNodes: [event.node], force: true });

        this.updateAllRowsValid();
    }

    updateAllRowsValid() {
        this.allRowsValid =
            this.customers.every(r => r.errors.length === 0) &&
            this.tanks.every(r => r.errors.length === 0);

        if (!this.allRowsValid) {
            setTimeout(() => this.scrollToFirstError(), 50);
        }
    }

    scrollToFirstError() {
        // Customers first
        for (let i = 0; i < this.customers.length; i++) {
            if (this.customers[i].errors.length > 0) {
                this.gridApiCustomers.ensureIndexVisible(i, 'top');
                return;
            }
        }

        // Then tanks
        for (let i = 0; i < this.tanks.length; i++) {
            if (this.tanks[i].errors.length > 0) {
                this.gridApiTanks.ensureIndexVisible(i, 'top');
                return;
            }
        }
    }

    save() {
        this.gridApiCustomers.stopEditing();
        if (this.gridApiTanks) {
            this.gridApiTanks.stopEditing();
        }

        if (!this.allRowsValid) return;

        this.isSaving = true;
        const payload: CustomersTanksSaveRequest = {
            customers: this.customers.map(c => ({
                ...c,
                companyName: c.companyName?.trim() || null,
                firstName: c.firstName?.trim() || null,
                lastName: c.lastName?.trim() || null,
                accountNumber: c.accountNumber?.trim() || null,
                email: c.email?.trim() || null,
                phone: c.phone?.trim() || null,
                addressStreet: c.addressStreet?.trim() || null,
                city: c.city?.trim() || null,
                state: c.state?.trim() || null,
                postalCode: c.postalCode?.trim() || null
            })),
            tanks: this.tanks.map(t => ({
                ...t,
                tankID: t.tankID?.trim() || null,
                tankType: t.tankType?.trim() || null,
                relatedCustomer: t.relatedCustomer?.trim() || null,
                addressStreet: t.addressStreet?.trim() || null,
                city: t.city?.trim() || null,
                state: t.state?.trim() || null,
                postalCode: t.postalCode?.trim() || null
            })),
            importType: "CustomersAndTanks",
            distributorId: this.selectedDistId!
        };

        this.importService.saveCustomersAndTanks(payload).subscribe({
            next: (response) => {
                this.toastService.success("Import completed successfully");
                this.isSaving = false;
                this.importCompleted.emit();
            },
            error: (err) => {
                console.error("Save failed", err);
                const message = err.error?.error || 'An unexpected error occurred.'; 
                this.isValidating = false;
                this.toastService.error(message);
            }
        });

    }

  validateFile(file: File) {
    setTimeout(() => {
      this.validated = true;
      this.errors = [];
    }, 600);
  }

  goBack() {
    this.back.emit();
  }
}
